import { FileTypeCopySink } from './file-type.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileShareDataset } from 'app/model/dataset/file-share.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.fileSystem.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(FileShareDataset) }
})
export class FileSystemSink extends FileTypeCopySink {
    public static readonly MODEL: IModel;
}
